import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitPersonalCopingAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitPersonalCopingAssessmentResultInput;
}>;


export type SubmitPersonalCopingAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitPersonalCopingAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitPersonalCopingAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & PersonalCopingAssessmentResultFragment
    )> }
  ) }
);

export type PersonalCopingAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'AitResult' } | { __typename: 'CardioRespResult' } | { __typename: 'DigitSpanResult' } | { __typename: 'GrowthMindsetResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | { __typename: 'OrganisationalAiReadinessResult' } | (
    { __typename: 'PersonalCopingResult' }
    & PersonalCopingAssessmentResultDataFragment
  ) | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type PersonalCopingAssessmentResultDataFragment = (
  { __typename: 'PersonalCopingResult' }
  & { surveys: Array<(
    { __typename: 'PersonalCopingSurveyResult' }
    & Pick<SchemaTypes.PersonalCopingSurveyResult, 'category' | 'question'>
    & { dimensionScores: Array<(
      { __typename: 'PersonalCopingDimensionScore' }
      & Pick<SchemaTypes.PersonalCopingDimensionScore, 'dimension' | 'dimensionInstruction'>
      & { scoring?: SchemaTypes.Maybe<(
        { __typename: 'LikertScaleResult' }
        & PersonalCopingLikertScaleResultFragment
      ) | (
        { __typename: 'RatingScaleResult' }
        & PersonalCopingRatingScaleResultFragment
      )> }
    )> }
  )>, dimensionAverages: Array<(
    { __typename: 'PersonalCopingDimensionAverage' }
    & Pick<SchemaTypes.PersonalCopingDimensionAverage, 'dimension' | 'maximumPossibleScore' | 'averageScore'>
  )>, categoryAverages: Array<(
    { __typename: 'PersonalCopingCategoryAverage' }
    & Pick<SchemaTypes.PersonalCopingCategoryAverage, 'category'>
    & { dimensionAverages: Array<(
      { __typename: 'PersonalCopingDimensionAverage' }
      & Pick<SchemaTypes.PersonalCopingDimensionAverage, 'dimension' | 'maximumPossibleScore' | 'averageScore'>
    )> }
  )>, resultAreas: Array<(
    { __typename: 'PersonalCopingResultAreaConfiguration' }
    & Pick<SchemaTypes.PersonalCopingResultAreaConfiguration, 'label' | 'xAxisFrom' | 'xAxisTo' | 'yAxisFrom' | 'yAxisTo' | 'color'>
  )> }
);

export type PersonalCopingLikertScaleResultFragment = (
  { __typename: 'LikertScaleResult' }
  & Pick<SchemaTypes.LikertScaleResult, 'type' | 'score' | 'total' | 'label'>
);

export type PersonalCopingRatingScaleResultFragment = (
  { __typename: 'RatingScaleResult' }
  & Pick<SchemaTypes.RatingScaleResult, 'type' | 'score' | 'minimumValue' | 'maximumValue'>
);

export const PersonalCopingLikertScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonalCopingLikertScaleResult on LikertScaleResult {
  type
  score
  total
  label
}
    `;
export const PersonalCopingRatingScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonalCopingRatingScaleResult on RatingScaleResult {
  type
  score
  minimumValue
  maximumValue
}
    `;
export const PersonalCopingAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonalCopingAssessmentResultData on PersonalCopingResult {
  surveys {
    category
    question
    dimensionScores {
      dimension
      dimensionInstruction
      scoring {
        __typename
        ... on LikertScaleResult {
          ...PersonalCopingLikertScaleResult
        }
        ... on RatingScaleResult {
          ...PersonalCopingRatingScaleResult
        }
      }
    }
  }
  dimensionAverages {
    dimension
    maximumPossibleScore
    averageScore
  }
  categoryAverages {
    category
    dimensionAverages {
      dimension
      maximumPossibleScore
      averageScore
    }
  }
  resultAreas {
    label
    xAxisFrom
    xAxisTo
    yAxisFrom
    yAxisTo
    color
  }
}
    ${PersonalCopingLikertScaleResultFragmentDoc}
${PersonalCopingRatingScaleResultFragmentDoc}`;
export const PersonalCopingAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment PersonalCopingAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on PersonalCopingResult {
      ...PersonalCopingAssessmentResultData
    }
  }
  createdAt
}
    ${PersonalCopingAssessmentResultDataFragmentDoc}`;
export const SubmitPersonalCopingAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitPersonalCopingAssessmentResult($input: SubmitPersonalCopingAssessmentResultInput!) {
  submitPersonalCopingAssessmentResult(input: $input) {
    ... on SubmitPersonalCopingAssessmentResultSuccessfulResponse {
      result {
        ...PersonalCopingAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${PersonalCopingAssessmentResultFragmentDoc}`;
export type SubmitPersonalCopingAssessmentResultMutationFn = Apollo.MutationFunction<SubmitPersonalCopingAssessmentResultMutation, SubmitPersonalCopingAssessmentResultMutationVariables>;

/**
 * __useSubmitPersonalCopingAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitPersonalCopingAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPersonalCopingAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPersonalCopingAssessmentResultMutation, { data, loading, error }] = useSubmitPersonalCopingAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPersonalCopingAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPersonalCopingAssessmentResultMutation, SubmitPersonalCopingAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPersonalCopingAssessmentResultMutation, SubmitPersonalCopingAssessmentResultMutationVariables>(SubmitPersonalCopingAssessmentResultDocument, options);
      }
export type SubmitPersonalCopingAssessmentResultMutationHookResult = ReturnType<typeof useSubmitPersonalCopingAssessmentResultMutation>;
export type SubmitPersonalCopingAssessmentResultMutationResult = Apollo.MutationResult<SubmitPersonalCopingAssessmentResultMutation>;
export type SubmitPersonalCopingAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitPersonalCopingAssessmentResultMutation, SubmitPersonalCopingAssessmentResultMutationVariables>;